import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { template } from 'lodash';
import useStyles from './Table.styles';
import { PROCESS_MODES_NAMES } from '../utils';
import Checkbox from '../../../checkbox/Checkbox';
import ThemedLink from '../../../themedLink/ThemedLink';
import LocaleContext from '../../../locale';
import { TABLE_FIELDS, TRANSACTION_FIELD_VARIANT } from './constants';

export const SharedRowPartComponent = ({
  cellClass,
  changeTransactionFieldVariant,
  field,
  fieldNameClassName,
  formState,
  onChange,
  processMode,
  sending,
  transactionFieldVariant,
  turnOnCheckboxes
}) => {
  const classes = useStyles();
  const locale = useContext(LocaleContext);
  const newTransactionVariant =
    transactionFieldVariant === TRANSACTION_FIELD_VARIANT.TRAN_TYPE
      ? TRANSACTION_FIELD_VARIANT.TRANSACTION_CODE
      : TRANSACTION_FIELD_VARIANT.TRAN_TYPE;

  const handleCheckboxCheck = useCallback(
    ({ target: { checked, id } }) => {
      const checkboxIdStr = id.split('_');
      const fieldId = checkboxIdStr[0];
      const checkboxType = checkboxIdStr[checkboxIdStr.length - 1];

      const anotherCheckboxId = `${fieldId}_${checkboxType === 'match' ? 'update' : 'match'}`;

      onChange(id, checked);
      onChange(anotherCheckboxId, false); // if match is selected = clear update checkbox, and vice versa
    },
    [onChange]
  );

  const onTransactionVariantChange = useCallback(
    (e) => {
      e.preventDefault();
      changeTransactionFieldVariant(newTransactionVariant);
    },
    [newTransactionVariant, changeTransactionFieldVariant]
  );

  const switchTo = template(locale['wireImports.switchTo'])({
    destination: locale[`wireImports.${newTransactionVariant}`]
  });

  return (
    <>
      <div
        className={classnames(cellClass, fieldNameClassName, {
          [classes.optionalName]: field.optional && processMode !== PROCESS_MODES_NAMES.UPDATE_ONLY
        })}
      >
        {field.name}
        {transactionFieldVariant &&
          (field.id === TABLE_FIELDS.TRAN_TYPE || field.id === TABLE_FIELDS.TRAN_CODE) && (
            <ThemedLink
              data-qa={switchTo}
              className={classes.switchTransactionRowLink}
              onClick={onTransactionVariantChange}
            >
              {switchTo}
            </ThemedLink>
          )}
      </div>

      {turnOnCheckboxes && (
        <>
          <div
            className={classnames(
              cellClass,
              classes.updateCheckboxCell,
              classes.updateCheckbox,
              'tableCheckbox'
            )}
          >
            {field.match && (
              <Checkbox
                id={`${field.id}_match`}
                checked={formState[`${field.id}_match`]}
                onChange={handleCheckboxCheck}
                disabled={sending}
              />
            )}
          </div>

          <div
            className={classnames(
              cellClass,
              classes.updateCheckboxCell,
              classes.updateCheckbox,
              'tableCheckbox'
            )}
          >
            {field.update && (
              <Checkbox
                id={`${field.id}_update`}
                checked={formState[`${field.id}_update`]}
                onChange={handleCheckboxCheck}
                disabled={sending}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

SharedRowPartComponent.propTypes = {
  field: PropTypes.shape({}).isRequired,
  cellClass: PropTypes.string,
  sending: PropTypes.bool.isRequired,
  formState: PropTypes.shape({}).isRequired,
  processMode: PropTypes.string.isRequired,
  turnOnCheckboxes: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  changeTransactionFieldVariant: PropTypes.func
};

SharedRowPartComponent.defaultProps = {
  cellClass: '',
  changeTransactionFieldVariant: null
};

export default SharedRowPartComponent;
